<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>草稿箱列表</span>
        <el-divider></el-divider>
      </p>
    </div>
    <div class="personal_live_list_box"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <div v-if="!listLoading && listData.length === 0" class="my_none">
        <img class="my_none_img" src="../../assets/img/user/articleListNone.png" alt="草稿列表为空"><br/>
        <span class="my_none_user_text">草稿箱空空如也！</span>
      </div>
      <div v-else>
        <div v-for="(item) in listData" :key="item.id" class="personal_live_list_item">
          <div class="personal_live_list_head">
            <p class="personal_live_list_title lf" @click="detail(item.id)">
              {{item.article_title}}
            </p>
            <p class="personal_live_list_time rt">
              {{item.add_time}}
            </p>
          </div>
          <div class="personal_live_list_foot">
            <div class="personal_live_other lf">
              <span v-if="item.name === ''" class="lf">未选择板块</span>
              <span v-else class="lf">{{item.name}}</span>
              <el-divider direction="vertical"></el-divider>
              <el-breadcrumb separator="·">
                <el-breadcrumb-item v-if="item.tag.length === 0">未选择标签</el-breadcrumb-item>
                <el-breadcrumb-item v-else v-for="n in item.tag" :key="n.id">{{n.name}}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="personal_live_btn rt">
              <span class="personal_live_btn_text" @click="detail(item.id)">查看</span>
              <el-divider direction="vertical"></el-divider>
              <span class="personal_live_btn_text" @click="edit(item.id)">编辑</span>
              <el-divider direction="vertical"></el-divider>
              <el-popconfirm
                class="personal_live_btn_text"
                title="确定删除改文章？"
                @onConfirm="del(item.id)"
              >
                <span slot="reference">删除</span>
              </el-popconfirm>
            </div>
          </div>
        </div>
        <el-pagination
        v-if="listData.length > 0"
        background
        layout="prev, pager, next"
        :page-size= "listLimit"
        :total="listNum"
        @current-change = "pageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      listData: [], // 草稿列表
      listNum: 0, // 草稿箱总条目
      listLimit: 5, // 列表当前页显示条目数
      listPage: 1, // 列表当前页码
      listLoading: true // 开启加载动画
    }
  },
  created () {
    this.pageChange()
  },
  methods: {
    // 查看详情
    detail (id) {
      this.$router.push({ name: 'ArticleDetail', params: { id: id } })
    },
    // 修改编辑
    edit (id) {
      const routeData = this.$router.resolve({
        path: '/articleApply',
        query: { id: id, type: 'draft' }
      })
      window.open(routeData.href, '_blank')
    },
    // 删除
    del (id) {
      const vueThat = this
      this.myApi.draftDel({ drafts_id: id }).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          vueThat.$alert('文章删除成功！', '温馨提示', {
            type: 'success',
            iconClass: 'iconfont icon-icon_richeng_btn_pass',
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              vueThat.loading = true
              vueThat.pageChange()
            }
          })
        }
      })
    },
    // 获取列表内容
    pageChange: function (index) {
      const vueThat = this
      if (index === undefined) {
        vueThat.listPage = 1
      } else {
        vueThat.listPage = index
      }
      const data = {
        limit: vueThat.listLimit,
        page: vueThat.listPage
      }
      vueThat.myApi.draftAdminList(data).then(function (res) {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.listData = res.data.data.list
          vueThat.listNum = res.data.data.count
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .personal_live_list_box{
    min-height: 500px;
  }
</style>
